import { useEffect } from 'react';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import createContextUtilities from '../../utils/createContextUtilities/75e5580757e6f68807f92e07850cfc0605a5ff6677179fbc573cffe4ac0a5df9.cfe-internal.js';

var _createContextUtiliti = createContextUtilities({}),
  FormFieldProvider = _createContextUtiliti.Provider,
  useFormFieldContext = _createContextUtiliti.useContext;
var useFormFieldControl = function useFormFieldControl() {
  var context = useFormFieldContext();
  var setHasControl = context.setHasControl;
  useEffect(function () {
    setHasControl === null || setHasControl === void 0 || setHasControl(true);
  }, [setHasControl]);
  return context;
};
var useFormFieldLabel = function useFormFieldLabel() {
  var context = useFormFieldContext();
  var setHasLabel = context.setHasLabel;
  useEffect(function () {
    setHasLabel === null || setHasLabel === void 0 || setHasLabel(true);
  }, [setHasLabel]);
  return context;
};
var useFormFieldType = function useFormFieldType(type) {
  var context = useFormFieldContext();
  var setFormFieldType = context.setFormFieldType;
  useEffect(function () {
    setFormFieldType === null || setFormFieldType === void 0 || setFormFieldType(type);
  }, [setFormFieldType, type]);
  return context;
};

export { FormFieldProvider, useFormFieldContext, useFormFieldControl, useFormFieldLabel, useFormFieldType };
